import React, { useEffect, useState } from "react";
import "./navbar.css";
import logo from "../../assets/images/logo.svg";
import avatar from "../../assets/images/avatar.png";

function Navbar() {
  useEffect(() => {
    const handleDocumentClick = (event) => {
      const trigger = document.querySelector(".header-user");
      if (trigger && !trigger.contains(event.target)) {
        document.querySelector(".user-dropdown-menu").classList.remove("active")
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleUserClick = () => {
    document.querySelector(".user-dropdown-menu").classList.toggle("active")
  };

  return (
    <nav className="header">
      <div className="page-padding">
        <div className="header-flex">
          {/* Header Left */}
          <div className="header-left">
            {/* Logo */}
            <div className="brand-logo">
              <img src={logo} alt="logo" />
            </div>

            {/* Navbar */}
            <div className="navbar-menu">
              <div className="navbar-list">
                <div className="item-navbar">
                  <a className="nav-link" href="#">
                    Dashboard
                  </a>
                </div>
                <div className="item-navbar">
                  <a className="nav-link" href="#">
                    Learning Materials
                  </a>
                </div>
                <div className="item-navbar">
                  <a className="nav-link active" href="#">
                    Audience
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* Header Right */}
          <div className="header-right">
            <div className="header-icons">
              <div className="item-header-icons">
                <a className="user-notification" href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12.0035 4C15.4207 4 17.8723 6.79005 17.8723 10.4099V11.7713C17.8723 11.9659 18.0368 12.2239 18.4855 12.6868C18.5431 12.7462 18.5973 12.8013 18.7156 12.9211C19.6359 13.8544 20 14.3921 20 15.2572C20 15.6355 19.9559 15.9304 19.7722 16.2838C19.3839 17.0307 18.5608 17.4468 17.3303 17.4468L15.7033 17.4477C15.1678 19.4328 13.8902 20.5108 12 20.5108C10.0897 20.5108 8.80504 19.4097 8.27983 17.3839L8.29617 17.4468H6.66965C5.40331 17.4468 4.57136 17.0193 4.19971 16.2463C4.0372 15.9082 4 15.6339 4 15.2572C4 14.3921 4.36415 13.8544 5.28436 12.9211C5.40272 12.8013 5.4569 12.7462 5.51445 12.6868C5.96319 12.2239 6.12766 11.9659 6.12766 11.7713V10.4099C6.12766 6.79146 8.58529 4 12.0035 4ZM14.0987 17.4484H9.90131C10.2893 18.5094 10.9581 18.9789 12 18.9789C13.0419 18.9789 13.7107 18.5094 14.0987 17.4484ZM12.0035 5.53192C9.47784 5.53192 7.65957 7.59717 7.65957 10.4099V11.7713C7.65957 12.4968 7.32813 13.0167 6.61447 13.753C6.55212 13.8174 6.49326 13.8771 6.37522 13.9967C5.73957 14.6414 5.53192 14.948 5.53192 15.2572C5.53192 15.4207 5.54344 15.5057 5.58036 15.5825C5.67168 15.7725 5.94886 15.9149 6.66965 15.9149H17.3303C18.0283 15.9149 18.3119 15.7715 18.4129 15.5772C18.455 15.4962 18.4681 15.4089 18.4681 15.2572C18.4681 14.948 18.2604 14.6414 17.6248 13.9967C17.5067 13.8771 17.4479 13.8174 17.3855 13.753C16.6719 13.0167 16.3404 12.4968 16.3404 11.7713V10.4099C16.3404 7.59519 14.5274 5.53192 12.0035 5.53192Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </div>
              <div className="item-header-icons">
                <a className="user-mail" href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.60606 6H8.5756H8.57557C7.92261 5.99999 7.3886 5.99999 6.9546 6.03544C6.50538 6.07215 6.09966 6.15044 5.72076 6.3435C5.12776 6.64564 4.64564 7.12776 4.3435 7.72076C4.15044 8.09966 4.07215 8.50538 4.03544 8.9546C3.99999 9.3886 3.99999 9.92261 4 10.5756V10.5756V10.6061V14.1616V14.1921V14.1921C3.99999 14.8451 3.99999 15.3791 4.03544 15.8131C4.07215 16.2623 4.15044 16.668 4.3435 17.0469C4.64564 17.6399 5.12776 18.122 5.72076 18.4242C6.09966 18.6172 6.50538 18.6955 6.9546 18.7322C7.3886 18.7677 7.92262 18.7677 8.57559 18.7677H8.60606H15.3939H15.4244C16.0774 18.7677 16.6114 18.7677 17.0454 18.7322C17.4946 18.6955 17.9003 18.6172 18.2792 18.4242C18.8722 18.122 19.3544 17.6399 19.6565 17.0469C19.8496 16.668 19.9279 16.2623 19.9646 15.8131C20 15.3791 20 14.8451 20 14.1921V14.1616V10.6061V10.5756C20 9.92262 20 9.3886 19.9646 8.9546C19.9279 8.50538 19.8496 8.09966 19.6565 7.72076C19.3544 7.12776 18.8722 6.64564 18.2792 6.3435C17.9003 6.15044 17.4946 6.07215 17.0454 6.03544C16.6114 5.99999 16.0774 5.99999 15.4244 6H15.4244H15.3939H8.60606ZM6.65102 7.54518C6.76057 7.51985 6.8968 7.49956 7.07305 7.48516C7.44081 7.45511 7.91521 7.45455 8.60606 7.45455H15.3939C16.0848 7.45455 16.5592 7.45511 16.927 7.48516C17.1032 7.49956 17.2394 7.51985 17.349 7.54518L14.1093 10.3799C13.6424 10.7884 13.3227 11.0675 13.0565 11.2666C12.7976 11.4602 12.6329 11.5439 12.4904 11.586C12.1703 11.6807 11.8297 11.6807 11.5096 11.586C11.3671 11.5439 11.2024 11.4602 10.9435 11.2666C10.6773 11.0675 10.3576 10.7884 9.89066 10.3799L6.65102 7.54518ZM5.57608 8.53737C5.53605 8.66317 5.50501 8.83009 5.48516 9.07305C5.45511 9.44081 5.45455 9.91521 5.45455 10.6061V14.1616C5.45455 14.8525 5.45511 15.3269 5.48516 15.6946C5.51451 16.0539 5.56834 16.2469 5.6395 16.3866C5.8022 16.7059 6.0618 16.9655 6.38111 17.1282C6.52078 17.1993 6.71377 17.2532 7.07305 17.2825C7.44081 17.3126 7.91521 17.3131 8.60606 17.3131H15.3939C16.0848 17.3131 16.5592 17.3126 16.927 17.2825C17.2862 17.2532 17.4792 17.1993 17.6189 17.1282C17.9382 16.9655 18.1978 16.7059 18.3605 16.3866C18.4317 16.2469 18.4855 16.0539 18.5148 15.6946C18.5449 15.3269 18.5455 14.8525 18.5455 14.1616V10.6061C18.5455 9.91521 18.5449 9.44081 18.5148 9.07305C18.495 8.83009 18.4639 8.66317 18.4239 8.53736L15.0672 11.4745L15.046 11.4931C14.6055 11.8785 14.2439 12.1949 13.9276 12.4314C13.599 12.6772 13.2764 12.8704 12.9029 12.9808C12.3136 13.1551 11.6864 13.1551 11.0971 12.9808C10.7236 12.8704 10.401 12.6772 10.0724 12.4314C9.75612 12.1949 9.39456 11.8785 8.95406 11.4931L8.93283 11.4745L5.57608 8.53737Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </div>
            </div>
            {/* Header-user */}
            <div className="header-user" onClick={handleUserClick}>
              <div className="user-avatar">
                <img src={avatar} alt="avatar" />
              </div>
              <div className="wrapper-user-name">
                <div className="user-name">Freja Begum</div>
                <div className="user-arrow-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.7803 7.71967C14.4874 7.42678 14.0126 7.42678 13.7197 7.71967L10 11.4393L6.28033 7.71967C5.98743 7.42678 5.51256 7.42678 5.21967 7.71967C4.92678 8.01257 4.92678 8.48744 5.21967 8.78033L9.46969 13.0303C9.76259 13.3232 10.2375 13.3232 10.5304 13.0303L14.7803 8.78033C15.0732 8.48743 15.0732 8.01256 14.7803 7.71967Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div className="user-dropdown-menu">
                <div className="user-dropdown-menu-list">
                  <div className="item-user-menu">
                    <a className="user-dropdown-menu-link" href="">
                      Logout
                    </a>
                  </div>
                  <div className="item-user-menu">
                    <a className="user-dropdown-menu-link" href="">
                      Setting
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <button className="menu-mobile" style={{ display: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="800px"
                height="800px"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill="currentColor"
                  fillRule="evenodd"
                  d="M19 4a1 1 0 01-1 1H2a1 1 0 010-2h16a1 1 0 011 1zm0 6a1 1 0 01-1 1H2a1 1 0 110-2h16a1 1 0 011 1zm-1 7a1 1 0 100-2H2a1 1 0 100 2h16z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
